import { Component } from "@angular/core";
import { CoreIcon } from "@svs/angular";

@Component({
  selector: "app-maintenance-disclaimer",
  imports: [
    CoreIcon,
  ],
  templateUrl: "./maintenance-disclaimer.component.html",
  styleUrl: "./maintenance-disclaimer.component.css",
})
export class MaintenanceDisclaimerComponent {
}

